import React, { useEffect, useState } from "react";
import { Steps, Button, Divider, Row, Col, Icon, Input } from "antd";

// Styles
import { StepsAction, StepsContent } from "./styles";

import SelectionArticle from "./selectionArticle";
import ConfigProcess from "./configProcess";
import Recommendations from "./recommendations";
import EndProcess from "./endProcess";

import moment from "moment";
import useProcessDesings from "../../hooks/useProcessDesings";

//import multilanguage library
import { useTranslation } from 'react-i18next'

const { Step } = Steps;



const DesingProcess = ({ changeTitle, edit, editArticle, editProcess, close }) => {
  const [current, setCurrent] = useState(edit ? 1 : 0);

  if (editProcess) {
    editProcess.furnace.enabled_ramp = editProcess.furnace.heating_ramp !== 5000;
    editProcess.tempered.enabled_ramp = editProcess.tempered.heating_ramp !== 5000;
  }

  const [article, setArticle] = useState(editArticle || null);
  const [process, setProcess] = useState(editProcess || null);
  const [recommendation, setRecommendation] = useState({
    furnace_time: 3600,
    quenching: 40,
    tempered_time: 3600
  });
  const [desingName, setDesingName] = useState((editProcess && editProcess.desingName) || "");

  const { saveData, updateData } = useProcessDesings();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("new_design");
  }, [changeTitle]);

  const next = () => {
    setCurrent(prev => prev + 1);
  };

  const prev = () => {
    setCurrent(prev => prev - 1);
  };

  const handleChangeArticle = art => setArticle(art);
  const handleChangeProcess = pro => setProcess(pro);
  const handleChangeRecommendation = rec => {
    let key = Object.keys(rec)[0];
    setRecommendation(prevState => ({ ...prevState, [key]: rec[key] }));
  };

  const isActive = () => {
    return desingName.length > 0;
  };

  const handleSave = () => {
    const newData = {
      desingName,
      articleId: article.id,
      furnace: {
        temperature: process.furnace.temperature,
        heating_ramp: process.furnace.enabled_ramp ? process.furnace.heating_ramp : 5000,
        piece_temperrature: process.furnace.piece_temperrature
      },
      quenching: {
        bath_type: process.quenching.bath_type,
        bath_temperature: process.quenching.bath_temperature,
        agitation_level: process.quenching.agitation_level,
        hard_coat: article.hard_coat
      },
      tempered: {
        temperature: process.tempered.temperature,
        heating_ramp: process.tempered.enabled_ramp ? process.tempered.heating_ramp : 5000,
        hardness_required: article.hardness_required
      },
      date: moment().format(),
      recommendation: {
        furnace_time: recommendation.furnace_time,
        quenching: recommendation.quenching,
        tempered_time: recommendation.tempered_time
      },
      article
    };

    if (!edit) {
      newData.id = new Date().getTime();
      saveData(newData);
      next();
    } else {
      newData.id = editProcess.id;
      updateData(newData);
      close();
    }

    //message.success("Diseño agregado");
    //setCurrent(0);
  };

  const finishDesing = () => {
    setCurrent(0);
    setArticle(null);
    setProcess(null);
    setDesingName("");
  };

  const steps = [
    {
      title: t('headers.design.article_selection'),
      content: <SelectionArticle handleChangeArticle={handleChangeArticle} article={article} />
    },
    {
      title: t('headers.design.process_configuration'),
      content: <ConfigProcess article={article} handleChangeProcess={handleChangeProcess} process={process} />
    },
    {
      title: t('headers.design.recommendations'),
      content: (
        <Recommendations
          article={article}
          process={process}
          recommendation={recommendation}
          handleChangeRecommendation={handleChangeRecommendation}
        />
      )
    },
    {
      title: t('headers.design.end'),
      content: <EndProcess name={desingName} finishDesing={finishDesing} />
    }
  ];

  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col span={24}>
        <Steps current={current}>
          {steps.map((item, i) =>
            edit && i === 3 ? null : <Step key={item.title} title={item.title} subTitle={i === 0 && article ? article.articleName : ""} />
          )}
        </Steps>

        <StepsAction>
          <Row gutter={[16, 16]} type="flex" justify={current === 0 ? "end" : "space-between"}>
            {current > 0 && current !== steps.length - 1 && (
              <Col>
                <Button disabled={edit && current === 1} onClick={prev}>
                  <Icon type="arrow-left" />
                  {t('button.prev')}
                </Button>
              </Col>
            )}
            {current < steps.length - 2 && (
              <Col>
                {edit && (
                  <Button onClick={() => close()}>
                    <Icon type="close" />
                    {t('button.cancel')}
                  </Button>
                )}
                {edit && <Divider type="vertical"></Divider>}
                <Button style={{ marginLeft: 8 }} type="primary" onClick={next} disabled={article && article.selected_figure === "cylinder" && article.grade === 1 ? false : true }>
                  {t('button.next')}
                  <Icon type="arrow-right" />
                </Button>
              </Col>
            )}
            {current === steps.length - 2 && (
              <Col>
                <Input
                  prefix={<Icon type="profile" style={{ color: "rgba(0,0,0,.25)" }} />}
                  value={desingName}
                  placeholder={t('placeholder.no_title')}
                  onChange={el => setDesingName(el.target.value)}
                  style={{ width: "200px" }}
                />
              </Col>
            )}
            {current === steps.length - 2 && (
              <Col>
                {edit && (
                  <Button onClick={() => close()}>
                    <Icon type="close" />
                    {t('button.cancel')}
                  </Button>
                )}
                {edit && <Divider type="vertical"></Divider>}
                <Button disabled={!isActive()} style={{ marginLeft: 8 }} type="primary" onClick={() => handleSave()}>
                  <Icon type="save" />
                  {edit ? t('button.update') : t('button.save')}
                </Button>
              </Col>
            )}
          </Row>
        </StepsAction>
        <StepsContent>{steps[current].content}</StepsContent>
      </Col>
    </Row>
  );
};
export default DesingProcess;
